function matchOption(input, options) {
    for (var i=0; i<options.length; i++) {
      var upper = parseInt(options[i].value.split('-').pop());
      if (input <= upper) {
        return options[i].value;
      }
    }
}

function hideVariant(postion) {
  var selectElements = document.getElementsByClassName("product-form__input product-form__input--dropdown");
  if (selectElements) {
      selectElements[postion].style.display = 'none';
    }
}

function changeVariant(id, value, article) {
  var selectElement = document.getElementById(id);
  if (selectElement) {
      selectElement.value = value;
      var event = new Event('change');
      var selects = document.getElementById("variant-selects-template--"+ article +"__main");
      selects.dispatchEvent(event);
    }
}
